import { useEffect } from 'react';
import { QuarantineLogTypeEnum } from '../../../types/log';
import { useGlobalSettingStore } from '../../../models/useGlobalSettingModel';
import {
  Flex,
  Link,
  Text,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';

export const RestoreAll = ({
  type,
  allRowChecked,
  selected,
  total,
  onClear: onClearProp,
  onSelectAll: onSelectAllProp,
  selectAllForRestore,
  setSelectAllForRestore,
}: {
  type: QuarantineLogTypeEnum;
  allRowChecked: boolean;
  selected: number;
  total: number;
  onClear: () => void;
  onSelectAll: () => void;
  selectAllForRestore: boolean;
  setSelectAllForRestore: (v: boolean) => void;
}) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation('quarantine');
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();

  const enabledRestoreAllService = [
    QuarantineLogTypeEnum.SharePoint,
    QuarantineLogTypeEnum.OneDrive,
    QuarantineLogTypeEnum.Exchange,
    QuarantineLogTypeEnum.Teams,
  ];

  useEffect(() => {
    if (!allRowChecked) {
      setSelectAllForRestore(false);
    }
  }, [allRowChecked, setSelectAllForRestore]);

  // global setting check
  if (!selectedOrgGlobalSetting.logRestoreAllFeatureShow) {
    return <></>;
  }

  if (
    !allRowChecked ||
    !enabledRestoreAllService.includes(type) ||
    selected < 100
  ) {
    return <></>;
  }

  const onSelectAll = () => {
    setSelectAllForRestore(true);
    onSelectAllProp();
  };

  const onClear = () => {
    setSelectAllForRestore(false);
    onClearProp();
  };

  return (
    <Flex
      height="56px"
      backgroundColor={colorStyle.background.secondary}
      alignItems="center"
      paddingLeft="14px"
      gap="4px"
    >
      {selectAllForRestore ? (
        <>
          <Text>{t('quarantine.restoreAll.AllSelected', { total })}</Text>
          <Link onClick={onClear}>{t('quarantine.restoreAll.clear')}</Link>
        </>
      ) : (
        <>
          <Text>
            {t('quarantine.restoreAll.partSelected', { selected, total })}
          </Text>
          <Link onClick={onSelectAll}>
            {t('quarantine.restoreAll.selectAll', { total })}
          </Link>
        </>
      )}
    </Flex>
  );
};
